import classNames from 'classnames';
import React from 'react';
import { InlineError, Tooltip } from '../';
import './FormControl.scss';

export interface FormControlProps extends Omit<React.HTMLProps<HTMLDivElement>, 'label'> {
  label?: React.ReactNode | React.ReactNode[];
  id: string;
  error?: string | boolean;
  tooltip?: string | React.ReactNode | React.ReactNode[];
  tooltipAriaLabel?: string;
  children: React.ReactNode | React.ReactNode[];
  helpText?: React.ReactNode | React.ReactNode[];
  hideLabel?: boolean;
  required?: boolean;
  pii?: boolean;
}

const FormControl: React.FC<FormControlProps> = ({
  label,
  id,
  error,
  tooltip,
  tooltipAriaLabel,
  children,
  helpText,
  hideLabel,
  required = false,
  pii = false,
  ...rest
}) => {
  const classes = classNames('mss-form-control', {
    'ctHidden pii-data': pii
  });

  return (
    <div className={classes} {...rest}>
      {label && (
        <div>
          <label
            className={classNames('mss-form-control-label', {
              'sr-only': hideLabel
            })}
            htmlFor={id}
          >
            {label}
            {required && (
              <span className="mss-form-control-required" aria-hidden>
                *
              </span>
            )}
          </label>
          {tooltip && (
            <Tooltip content={tooltip} buttonProps={{ 'aria-label': tooltipAriaLabel }} />
          )}
        </div>
      )}
      {helpText && <div>{helpText}</div>}
      <div className="mss-form-control__input">{children}</div>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {((error as any) instanceof String || typeof error === 'string') && (
        <InlineError error={error as string} id={id} />
      )}
    </div>
  );
};

export default FormControl;
